module.exports = __webpack_public_path__ + "static/media/acc-icon4.89760d15.svg";